import PropTypes from 'prop-types';
import React from 'react';

import Button from '../Button';
import styles from './empty.scss';

const propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  empty: PropTypes.bool,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  button: PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    text: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.element.isRequired,
    ]),
  }),
  error: PropTypes.bool,
  onReload: PropTypes.func,
};

const Empty = ({
  empty,
  title,
  message,
  button,
  error,
  onReload,
}) => {
  // Don't show error message unless the content is also empty. This is because
  // cached conten't can still show up, and then the offline notice should be
  // the main way to indicate that we're offline.
  const isError = empty && error;
  return (
    (empty || isError)
      ? (
        <div className={styles.empty}>
          <div className={styles.title}>
            { isError ? 'Something went wrong' : title}
          </div>
          { message
          && (
          <div className={styles.message}>
            { isError ? 'Looks like we couldn\'t reach DreamHack. Try again in a moment.' : message}
          </div>
          )}
          { ((isError && onReload) || button)
          && (
          <Button onClick={(isError && onReload) || button.onClick}>
            { isError
              ? (
                <span>
                  <i className="far fa-sync" />
                  {' '}
                  Reload
                </span>
              )
              : button.text}
          </Button>
          )}
        </div>
      )
      : null
  );
};

Empty.propTypes = propTypes;
Empty.defaultProps = {
  title: 'We couldn\'t find anything',
};

export default Empty;
